<!-- Loading -->
<app-loading *ngIf="contentReady"></app-loading>

<div class="bb-page" *ngIf="!contentReady">
  <div class="bb-page-shell">

    <!-- Header -->
    <div class="bb-page-header">
      <div class="bb-page-title-block">
        <h2 class="bb-page-title">{{ 'Transaction History' | transloco }}</h2>
      </div>
    </div>

    <!-- Summary Cards -->
    <div class="bb-filter-card" *ngIf="summary">
      <div class="bb-filter-grid">

        <!-- Customer Owes -->
        <div class="bb-card bb-p-20">
          <div class="bb-text-muted bb-font-semibold bb-mb-8">{{ "company_due_from_him" | transloco }}</div>
          <div class="bb-text-success bb-font-bold">
            {{ summary.customer_owes | number:'1.0-2' }}
            <small class="bb-text-muted">{{ "egp" | transloco }}</small>
          </div>
        </div>

        <!-- Company Owes -->
        <div class="bb-card bb-p-20">
          <div class="bb-text-muted bb-font-semibold bb-mb-8">{{ "company_owes_him" | transloco }}</div>
          <div class="bb-text-danger bb-font-bold">
            {{ summary.company_owes | number:'1.0-2' }}
            <small class="bb-text-muted">{{ "egp" | transloco }}</small>
          </div>
        </div>

        <!-- Adjust Balance Button -->
        <div class="bb-filter-actions" *ngIf="isAdmin">
          <button class="bb-btn bb-btn-primary" (click)="openAdjustBalanceDialog()">
            {{ 'adjust_opening_balance' | transloco }}
          </button>
        </div>

      </div>
    </div>

    <!-- Transactions Table -->
    <div class="bb-table-card">
      <div class="bb-table-scroll">
        <table class="bb-table table-custom">
          <thead>
            <tr class="mat-header-row-custom">
              <th class="mat-header-cell-custom">{{ "date" | transloco }}</th>
              <th class="mat-header-cell-custom">{{ "details" | transloco }}</th>
              <th class="mat-header-cell-custom">{{ "amount" | transloco }}</th>
              <th class="mat-header-cell-custom">{{ "balance" | transloco }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let element of dataSource.data" class="mat-row-custom">
              <!-- Date & Type -->
              <td class="mat-cell-custom">
                <div class="bb-text-stack">
                  <span class="bb-badge" [class]="getTypeClass(element.type)">
                    {{ getTypeLabel(element.type) }}
                  </span>
                  <small class="bb-text-muted">{{ element.date | date:'dd/MM/yyyy - HH:mm' }}</small>
                </div>
              </td>

              <!-- Details (Clickable) -->
              <td class="mat-cell-custom">
                <span *ngIf="element.ref_id" (click)="details(element.ref_id, element.type)"
                  class="bb-link-action bb-inline-flex">
                  #{{ element.ref_id }}
                </span>
                <span *ngIf="!element.ref_id" class="bb-text-muted">—</span>
              </td>

              <!-- Amount -->
              <td class="mat-cell-custom">
                <strong class="bb-price">{{ element.amount | number:'1.0-2' }}</strong>
                <small class="bb-text-muted"> {{ "egp" | transloco }}</small>
              </td>

              <!-- Balance -->
              <td class="mat-cell-custom">
                <span class="bb-text-blue bb-font-semibold">
                  {{ element.balance !== null ? (element.balance | number:'1.0-2') : '—' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- No Data State -->
      <div *ngIf="noData" class="bb-empty-state">
        <app-nodata></app-nodata>
      </div>
    </div>

  </div>
</div>

<!-- Adjust Balance Popup Modal -->
<div *ngIf="showadd" class="bb-modal-backdrop popup" (click)="close()">
  <div class="bb-modal-card popup-box" (click)="$event.stopPropagation()">

    <!-- Close Button -->
    <button class="bb-modal-close" (click)="close()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M18 6L6 18M6 6l12 12" />
      </svg>
    </button>

    <!-- Popup Content -->
    <div class="bb-grid bb-gap-16">

      <!-- Icon -->
      <div class="bb-flex bb-justify-center">
        <span class="bb-product-img-box">
          <img src="/assets/income.png" [alt]="'balance' | transloco" />
        </span>
      </div>

      <!-- Form -->
      <form class="bb-grid bb-gap-16">

        <!-- Amount -->
        <div class="bb-field">
          <label class="bb-label" for="amount">{{ "amount" | transloco }}</label>
          <input class="bb-input" id="amount" type="number" min="0" [(ngModel)]="amount"
            [ngModelOptions]="{standalone: true}" placeholder="{{ 'Enter amount' | transloco }}" />
        </div>

        <!-- Direction Radio Buttons -->
        <div class="bb-field">
          <label class="bb-label">{{ "direction" | transloco }}</label>
          <div class="bb-grid bb-gap-12">
            <label class="bb-check-line">
              <input class="bb-checkbox" type="radio" name="direction" [(ngModel)]="direction" [value]="'1'"
                [ngModelOptions]="{standalone: true}" />
              <span>{{ "add_to_him" | transloco }} (+)</span>
            </label>
            <label class="bb-check-line">
              <input class="bb-checkbox" type="radio" name="direction" [(ngModel)]="direction" [value]="'2'"
                [ngModelOptions]="{standalone: true}" />
              <span>{{ "add_on_him" | transloco }} (−)</span>
            </label>
          </div>
        </div>

        <!-- Submit -->
        <div class="bb-modal-actions">
          <button class="bb-btn bb-btn-primary" type="button" (click)="onSubmit()"
            [disabled]="!amount || amount <= 0 || !direction">
            {{ "Submit" | transloco }}
          </button>
        </div>

      </form>

    </div>
  </div>
</div>